import React from 'react';
import { Row, Col, Title, QuestionNumberBadge } from '../../../../styles/common';
import { BadgetWrongRightAnswer } from './styles';
import checkIcon from 'img/check.svg';
import timesWhiteIcon from 'img/times-white.svg';
import { MESSAGES } from '../../../ObjectiveQuestion/utils/constants';

interface QuestionHeaderProps {
  questionNumber?: number;
  totalQuestions?: number;
  currentStep?: number;
  totalSteps?: number;
  questionAnswer?: number;
  questionAnswerCorrect?: number;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  questionNumber,
  totalQuestions,
  currentStep,
  totalSteps,
  questionAnswer,
  questionAnswerCorrect,
}) => {
  const isCorrect = questionAnswerCorrect === questionAnswer;
  const showBadge = questionAnswerCorrect !== undefined;

  return (
    <Row padding="0 24px" width="100%">
      <Col width="100%">
        {/* Só a posição na prova. O tipo e o código ficam no cabeçalho do step,
            ao lado do enunciado: cada step é avaliado por conta própria e pode
            ocupar sua própria posição na prova, então é ele que identifica a
            questão que o aluno está respondendo. */}
        <Title>
          {questionNumber && totalQuestions && (
            <QuestionNumberBadge>
              <p>{questionNumber}/{totalQuestions}</p>
            </QuestionNumberBadge>
          )}
        </Title>
      </Col>
      <Col alignItems="flex-end" height="28px">
        {showBadge && (
          <BadgetWrongRightAnswer className={isCorrect ? 'is-correct' : 'is-incorrect'}>
            {isCorrect ? (
              <img src={checkIcon} alt="" width={16} height={16} />
            ) : (
              <img src={timesWhiteIcon} alt="" width={16} height={16} />
            )}
            <p>{isCorrect ? MESSAGES.YOU_GOT_IT_RIGHT : MESSAGES.YOU_GOT_IT_WRONG}</p>
          </BadgetWrongRightAnswer>
        )}
      </Col>
    </Row>
  );
};
